import { FC, ReactNode } from "react";
import Button from "../common/F7/Button";
import ContentTitle from "../common/F7/ContentTitle";
import Page from "../common/navigation/Page";
import { useLastInventoryId } from "../../state";
import { useListProjects } from "../../hooks/database/usePouchList";
import Spinner from "../common/F7/Spinner";
import BackButton from "../common/navigation/BackButton";

const ButtonGroup: FC<{ children: ReactNode }> = ({ children }) => (
  <div
    style={{
      marginBottom: 30,
      marginTop: -20,
    }}
  >
    {children}
  </div>
);

const DatabasePage: FC = () => {
  const lastInventoryId = useLastInventoryId();
  const { data: projects } = useListProjects();

  if (!projects) {
    return <Spinner />;
  }

  const lastProject = lastInventoryId === null ? undefined : projects.find((p) => p.inventories && lastInventoryId in p.inventories);
  const lastInventory = lastInventoryId === null ? undefined : lastProject?.inventories?.[lastInventoryId];

  return (
    <Page navbarLeft={<BackButton />} title="Welcome!">
      <div
        style={{
          textAlign: "center",
        }}
      >
        {lastInventory ? (
          <ButtonGroup>
            <ContentTitle>Last Opened Inventory</ContentTitle>
            <Button to={`i/${lastInventoryId}`}>{lastInventory.name}</Button>
          </ButtonGroup>
        ) : null}
        <ButtonGroup>
          <ContentTitle>Quick Links</ContentTitle>
          <Button to="p">All projects</Button>
        </ButtonGroup>
        {lastProject ? (
          <ButtonGroup>
            <ContentTitle>{lastProject.name} Inventories</ContentTitle>
            {Object.entries(lastProject.inventories || {}).map(([key, inventory]) => (
              <Button key={key} to={`i/${key}`}>
                {inventory.name}
              </Button>
            ))}
          </ButtonGroup>
        ) : null}
      </div>
    </Page>
  );
};

export default DatabasePage;
